import { useState } from "react";

/**
 * GDPR consent checkbox, riutilizzabile in tutti i form.
 *
 * Props:
 * - checked: boolean
 * - onChange: (checked: boolean) => void
 * - variant: "light" (default, su bg chiaro) | "dark" (su bg scuro)
 * - testId: string
 */
export default function GdprConsent({ checked, onChange, variant = "light", testId = "gdpr-consent" }) {
  const isDark = variant === "dark";
  const textColor = isDark ? "text-on-dark-muted" : "text-lovac-muted";
  const linkColor = "text-lovac-accent hover:underline";

  return (
    <label
      className={`flex items-start gap-3 text-xs sm:text-sm leading-relaxed cursor-pointer ${textColor}`}
      data-testid={`${testId}-wrap`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        required
        data-testid={testId}
        className="mt-1 h-4 w-4 rounded shrink-0 accent-[#00C48C] cursor-pointer"
      />
      <span>
        Ho letto e accetto la{" "}
        <a
          href="https://lovac.it/privacy-policy"
          target="_blank"
          rel="noreferrer"
          className={linkColor}
          onClick={(e) => e.stopPropagation()}
        >
          Privacy Policy
        </a>{" "}
        ai sensi del GDPR (Reg. UE 2016/679)
      </span>
    </label>
  );
}

/** Hook helper per gestire lo stato del consenso */
export function useGdprConsent() {
  const [accepted, setAccepted] = useState(false);
  return [accepted, setAccepted];
}
